import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";
import { ReduxStateType } from "redux-store/types";

const internalDocumentSelector = (state: RootState) => state.internalDocument;

const formSearchSelector = createSelector(
  internalDocumentSelector,
  (state) => state.fromSearchInternalDocumentSlice
);

export const formSearchSelectorDataSelector = createSelector(
  formSearchSelector,
  (state) => state.formData
);

export const searchStateDataSelector = createSelector(
  formSearchSelector,
  (state) => state.isSearching
);

// get menu
const menuSelector = createSelector(
  internalDocumentSelector,
  (state) => state.menuInternalDocumentSlice
);

const menuItemSelector = createSelector(
  menuSelector,
  (state) => state.menuData
);

export const menuItemDataSelector = createSelector(
  menuItemSelector,
  (state) => state.data
);

export const menuItemStatusSelector = createSelector(
  menuItemSelector,
  (state) => state.status
);

const subMenuItemSelector = createSelector(
  menuSelector,
  (state) => state.subMenuData
);

export const subMenuItemDataSelector = (id: string) =>
  createSelector(subMenuItemSelector, (state) => state[id]?.data);

export const subMenuItemStatusSelector = (id: string) =>
  createSelector(
    subMenuItemSelector,
    (state) => state[id].status || ReduxStateType.INIT
  );

export const subMenuItemIsOpenSelector = (id: string) =>
  createSelector(subMenuItemSelector, (state) => state[id]?.isOpen || false);

// get detail
const detailSelector = createSelector(
  internalDocumentSelector,
  (state) => state.getDetailSlice
);

export const detailDataSelector = createSelector(
  detailSelector,
  (state) => state.data
);

export const detailStatusSelector = createSelector(
  detailSelector,
  (state) => state.status
);

// get list

const listInternalDocumentSelector = createSelector(
  internalDocumentSelector,
  (state) => state.getListInternalDocsSlice
);

export const listInternalDocumentByTypeSelector = (type: string) =>
  createSelector(listInternalDocumentSelector, (state) =>
    state[type] ? state[type]?.data : []
  );

export const listInternalDocumentTotalRecordByTypeSelector = (type: string) =>
  createSelector(listInternalDocumentSelector, (state) =>
    state[type] ? state[type]?.totalRecords : 0
  );

export const listInternalDocumentCategoryNameByTypeSelector = (type: string) =>
  createSelector(listInternalDocumentSelector, (state) =>
    state[type] ? state[type]?.categoryName : ""
  );

export const listInternalDocumentsStatusByTypeSelector = (type: string) =>
  createSelector(listInternalDocumentSelector, (state) =>
    state[type] ? state[type]?.status : ReduxStateType.INIT
  );

export const listDocFormSelector = createSelector(
  internalDocumentSelector,
  (state) => state.getListDocFormSlice
);

export const listDocFormTotalRecordSelector = createSelector(
  listDocFormSelector,
  (state) => state.totalRecords
);

export const listDocFormDataSelector = createSelector(
  listDocFormSelector,
  (state) => state.data
);

export const listDocFormStatusSelector = createSelector(
  listDocFormSelector,
  (state) => state.status
);
